import { z } from 'zod'

export const errorEnvelopeSchema = z.object({
  code: z.string(),
  message: z.string(),
  // PostgREST sends hint:null (not omitted) for errors without a hint; tolerate
  // null and normalize to undefined so envelope.code survives the parse — else
  // apiClient falls back to HTTP-<status> and the 57014/code-based logic breaks.
  hint: z
    .string()
    .nullish()
    .transform((v) => v ?? undefined),
})

export type ApiErrorEnvelope = z.infer<typeof errorEnvelopeSchema>

export class ApiError extends Error {
  constructor(
    public readonly envelope: ApiErrorEnvelope,
    public readonly status: number,
    public readonly url: string,
  ) {
    super(envelope.message)
    this.name = 'ApiError'
  }
}

/**
 * A walk grouped by a dimension the fact does not carry. PG returns a row with
 * dims:{<dim>:null}; the parse layer detects that shape and throws this typed error
 * (kept LOUD per "no silent fallbacks", but recognizable so tiles render a precise
 * note instead of a generic load-failure). `dims` lists the offending dimension names.
 */
export class DimNotApplicableError extends Error {
  constructor(public readonly dims: string[]) {
    super(`Group-by dimension(s) not applicable: ${dims.join(', ')}`)
    this.name = 'DimNotApplicableError'
  }
}
